<div class="payment-instruction text-center">
    <img class="img-fluid" style="padding: 5em; height: 21rem;"
    [src]="coreConfig.layout.skin === 'dark' ? 'assets/images/payments/iphone_spinner.svg' : 'assets/images/payments/iphone_spinner.svg' "
    alt="Error page" />
        <!-- <div class="row">
            <div class="col-sm-10 col-md-10 col-xl-7 mx-auto">
                <div class="card mt-2">
                    <div class="card-body">
                            <h3 class="bold">Send Instructions</h3><br>
                            <ng-container *ngIf="careersPlan; else normalPlan">
                                <p class="font">Do you want to pay {{careersPlan?.amount | currency:'KES '}} to<br>
                                    ZERAKI Account no. learning_test?<br><br>
                                    ENTER M-PESA PIN:</p>
                            </ng-container>
                            <ng-template #normalPlan>
                                <p class="font">Do you want to pay {{(paymentInfo?.plan?.hasDiscount ? paymentInfo?.plan?.discountedAmount : paymentInfo?.plan?.amount)  | currency:'KES '}} to<br>
                                    ZERAKI Account no. learning_test?<br><br>
                                    ENTER M-PESA PIN:</p>
                            </ng-template>

                            <hr class="mpesa-pin-line">
                            <div class="flex">
                                <p class="action-buttons ml-2">Cancel</p>
                                <p class="action-buttons mr-2">Send</p>
                            </div>
                    </div>
                </div>
                
            </div>
        </div> -->
   

    <p class="mb-2 fs-sm-16" style="
                    color: #555555;
                    ">A prompt has been sent to the phone number you provided, complete the transaction by entering your pin.</p>
</div>
<div class="row">

    <div class="form-group text-left" style="text-align: left">

<!--        <a class="btn btn-outline-success" (click)="loadHomepage()">Cancel-->
<!--            &lt;!&ndash; <i data-feather="arrow-right" class="cursor-pointer"></i> &ndash;&gt;-->
<!--        </a>-->
        <a href=""></a>
    </div>
</div>